export default __webpack_public_path__ + "static/media/haven.70ba2f31.png";